import React, { useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import ImageDropzone from './ImageDropzone';

// Shows the picked file under the zone so drops and browsing can be checked by hand
const DropzoneWithResult = props => {
  const [file, setFile] = useState(null);
  return (
    <div style={{ maxWidth: 800 }}>
      <ImageDropzone {...props} onFileSelected={setFile} />
      <p data-testid="picked">{file ? `Picked: ${file.name} (${file.type})` : 'Nothing picked'}</p>
    </div>
  );
};

export const Default = {
  component: DropzoneWithResult,
  props: {
    id: 'ImageDropzoneExample.default',
    hint: <FormattedMessage id="ImageDropzone.hint" />,
  },
  group: 'inputs',
};

export const Disabled = {
  component: DropzoneWithResult,
  props: {
    id: 'ImageDropzoneExample.disabled',
    hint: <FormattedMessage id="ImageDropzone.hint" />,
    disabled: true,
  },
  group: 'inputs',
};
